import React from 'react';

interface EMDGheaderBrandProps {
    title: string;
    level?: '1' | '2' | '3' | '4' | '5' | '6';
    subline?: string;
    brandImage: string;
    brandImageAlt: string;
    link: string;
    className?: string;
    children?: React.ReactNode; // Include children prop in the interface
}

const EMDGheaderBrand: React.FC<EMDGheaderBrandProps> = ({
    title,
    level = '1',
    subline,
    brandImage,
    brandImageAlt,
    link,
    className = '',
    children, // Include children in the destructured props
}) => {
    const HeadingTag = `h${level}` as keyof JSX.IntrinsicElements;

    // Define LinkComponent based on the presence of the 'link' prop
    const LinkComponent = link ? 'a' : 'div';
    const linkProps = link ? { href: link } : {};

    return (
        <LinkComponent className={`emdg-header__brand ${className}`} {...linkProps}>
            <img className="emdg-header__brand-image" alt={brandImageAlt} src={brandImage} />
            <div className="emdg-header__text">
                {title && <HeadingTag className="emdg-header__heading">{title}</HeadingTag>}
                {subline && <div className="emdg-header__subline">{subline}</div>}
                {children} {/* Render children if provided */}
            </div>
        </LinkComponent>
    );
};

export default EMDGheaderBrand;
